'use client';

import { c as _c } from "react/compiler-runtime";
import { BarChart3Icon, BookCheckIcon, Building2Icon, CalendarCheckIcon, HelpCircleIcon, LayoutDashboardIcon, MessageSquareIcon, SettingsIcon, Share2Icon, SparklesIcon, UsersIcon, VideoIcon } from 'lucide-react';
import * as React from 'react';
import { RevallySidebar, type RevallySidebarMenu } from '@/components/layout/sidebar';
import { Sidebar } from '@/components/ui/sidebar';
const menu: RevallySidebarMenu = [{
  title: 'Reviews',
  items: [{
    title: 'Dashboard',
    href: '/app/dashboard',
    icon: LayoutDashboardIcon,
    color: 'text-blue-500'
  }, {
    title: 'Reviews',
    href: '/app/reviews',
    icon: MessageSquareIcon,
    color: 'text-green-500'
    // disabled: true,
    // badge: 'Soon',
  }, {
    title: 'Analytics',
    href: '/app/analytics',
    icon: BarChart3Icon,
    color: 'text-purple-500'
    // badge: 'Soon',
  }]
}, {
  title: 'Social networks',
  items: [{
    title: 'Social Media',
    icon: Share2Icon,
    color: 'text-pink-500',
    disabled: true,
    badge: 'Soon'
  }, {
    title: 'Video Generator',
    icon: VideoIcon,
    color: 'text-red-500',
    disabled: true,
    badge: 'Soon'
  }]
}, {
  title: 'Business management',
  items: [{
    title: 'AI Insights',
    icon: SparklesIcon,
    color: 'text-cyan-500',
    disabled: true,
    badge: 'Preview'
  }, {
    title: 'Bookings',
    icon: CalendarCheckIcon,
    color: 'text-teal-500',
    disabled: true,
    badge: 'Soon'
  }, {
    title: 'Affiliation',
    icon: UsersIcon,
    color: 'text-pink-500',
    disabled: true,
    badge: 'Soon'
  }, {
    title: 'Business',
    href: '/app/business',
    icon: Building2Icon,
    color: 'text-indigo-500'
  }, {
    title: 'Listings',
    href: '/app/listings',
    icon: BookCheckIcon,
    color: 'text-violet-500'
  }, {
    title: 'Help',
    icon: HelpCircleIcon,
    color: 'text-orange-500',
    disabled: true
  }, {
    title: 'Settings',
    href: '/app/settings',
    icon: SettingsIcon,
    color: 'text-orange-500'
  }]
}];
export function AppSidebar(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <RevallySidebar menu={menu} {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}